import {
  IdentifierType,
  NORMALIZE_PHONE_NUMBER,
} from '@transcend-io/privacy-types';

import { isIdentifierType } from '@main/datamap-types';
import type { DeprecatedRequestIdentifiersInput } from '@main/sombra-types';

/**
 * Map the freeform form values to request identifiers
 *
 * @param formValues - The dynamic form values
 * @returns The request identifiers mapping
 */
export function formToRequestIdentifiers(formValues: {
  [k in string]: string;
}): DeprecatedRequestIdentifiersInput {
  const input: DeprecatedRequestIdentifiersInput = {};

  Object.entries(formValues).forEach(([name, value]) => {
    if (
      !value ||
      typeof value !== 'string' ||
      name === IdentifierType.CoreIdentifier
    ) {
      return;
    }
    if (isIdentifierType(name)) {
      if (!input[name]) {
        input[name] = [];
      }

      let newValue = value;
      if (name === IdentifierType.Phone) {
        newValue = newValue.startsWith('+') ? newValue : `+${newValue}`;
        newValue = newValue.replace(NORMALIZE_PHONE_NUMBER, '');
      }
      if (name === IdentifierType.Email) {
        newValue = newValue.toLowerCase();
      }

      input[name]!.push({
        value: newValue,
      });
    } else {
      if (!input.custom) {
        input.custom = [];
      }
      input.custom.push({ value, name });
    }
  });

  return input;
}
